import { useTranslationDetector } from "@/hooks/useTranslationDetector";

const AboutHotel = ({ hotelData }) => {
  const t = useTranslationDetector('hotel');

  // API'den gelen Descriptions'ı kullan
  const descriptions = hotelData?.Descriptions || [];

  // Location, Attractions, Rooms, Business Amenities, Dining, Amenities gibi kategorileri al
  const locationDesc = descriptions.find(d => d.Category === 'Location')?.Content;
  const attractionsDesc = descriptions.find(d => d.Category === 'Attractions')?.Content;
  const roomsDesc = descriptions.find(d => d.Category === 'Rooms')?.Content;
  const businessDesc = descriptions.find(d => d.Category === 'Business Amenities')?.Content;
  const diningDesc = descriptions.find(d => d.Category === 'Dining')?.Content;
  const amenitiesDesc = descriptions.find(d => d.Category === 'Amenities')?.Content;
  const summary = hotelData?.Summary || hotelData?.Description;

  // İçerik varsa göster
  const hasContent = locationDesc || roomsDesc || businessDesc || diningDesc || amenitiesDesc || summary;

  // Eğer içerik yoksa section'u hiç render etme
  if (!hasContent) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl sm:text-[23px] md:text-[29px]! font-semibold">
        {t('hotelAboutSection')}
      </div>

      <div className="leading-[21px] flex flex-col gap-4 text-sm md:text-base">
        {summary && (
          <p dangerouslySetInnerHTML={{ __html: summary }} />
        )}
        {locationDesc && (
          <p dangerouslySetInnerHTML={{ __html: locationDesc }} />
        )}
        {roomsDesc && (
          <p dangerouslySetInnerHTML={{ __html: roomsDesc }} />
        )}
        {businessDesc && (
          <p dangerouslySetInnerHTML={{ __html: businessDesc }} />
        )}
        {diningDesc && (
          <p dangerouslySetInnerHTML={{ __html: diningDesc }} />
        )}
        {amenitiesDesc && (
          <p dangerouslySetInnerHTML={{ __html: amenitiesDesc }} />
        )}
        {attractionsDesc && (
          <div dangerouslySetInnerHTML={{ __html: attractionsDesc }} />
        )}
      </div>
    </div>
  )
};

export default AboutHotel;